import {pickColor} from "styles";
import {Children, Clickable} from "interfaces";
import {fontSizeObj} from "./helper";
import {TypographyVariant} from "./types";
import {useTheme} from "styled-components";
import {CSSProperties, MutableRefObject, ReactNode} from "react";

export type FontFamily =
  | "Rubik"
  | "Rubik-Bold"
  | "Rubik-Light"
  | "Rubik-Medium"
  | "Rubik-SemiBold";

export interface TypographyProps
  extends Children<ReactNode>,
    CSSProperties,
    Partial<Clickable> {
  className?: string;
  fontFamily?: FontFamily;
  variant?: TypographyVariant;
  ref?: MutableRefObject<any>;
}

export const Typography: React.FC<TypographyProps> = (props) => {
  const {mode} = useTheme();
  const {
    ref,
    onClick,
    children,
    className,
    variant = "normal",
    ...style
  } = props;
  const {
    fontFamily = "Rubik",
    color = pickColor(mode),
    fontSize = fontSizeObj[variant],
  } = style;

  return (
    <span
      ref={ref}
      onClick={onClick}
      children={children}
      className={className}
      style={{fontFamily, color, fontSize, ...style}}
    />
  );
};
